

var keyboardShortcuts = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function() {
		var elements = document.querySelectorAll('[data-keyboard-shortcut]');
		var key;
		if (typeof elements !== 'undefined') {
			document.addEventListener('keyup', function(event) {
				for (let [index, element] of Object.entries(elements)) {
					key = elements[index].getAttribute('data-keyboard-shortcut') || null;
					if (key !== null) {
						if (event.ctrlKey && event.altKey && event.shiftKey && event.code === ('Key' + key)) {
							var clickEvent = new Event('click');
							element.dispatchEvent(clickEvent);
						}
					}
				}

			});
		}
	}

};

export default keyboardShortcuts;
